module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre5 sgc-46 sigil_not_in_toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#sigil_toc_id_1"
    }
  }, [_vm._v("The Truth about America’s First Peoples")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#sigil_toc_id_2"
    }
  }, [_vm._v("In the Pages to Follow . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#sigil_toc_id_3"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica"
    }
  }, [_vm._v("Ancient America")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica#sigil_toc_id_4"
    }
  }, [_vm._v("Who Are the American Indians?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica#sigil_toc_id_5"
    }
  }, [_vm._v("First Peoples")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica#sigil_toc_id_6"
    }
  }, [_vm._v("The Mound Builders")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica#sigil_toc_id_7"
    }
  }, [_vm._v("Cliff Dwellings, Great Houses, and Stone Towers")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AncientAmerica#sigil_toc_id_8"
    }
  }, [_vm._v("Rock Art")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2 sgc-50 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Peoples and Mound Builders")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Peoples")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter01#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("1.")]), _vm._v(" Meadowcroft Rockshelter • Avella, Pennsylvania")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mound Builders")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter02#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("2.")]), _vm._v(" Moundville Archaeological Park • Moundville, Alabama")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("3.")]), _vm._v(" Toltec Mounds Archaeological State Park • Scott, Arkansas")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("4.")]), _vm._v(" Crystal River Archaeological State Park • Crystal River, Florida")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("5.")]), _vm._v(" Kolomoki Mounds State Park • Blakely, Georgia")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("6.")]), _vm._v(" Rock Eagle Effigy Mound • Eatonton, Georgia")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("7.")]), _vm._v(" Etowah Indian Mounds State Historic Site • Etowah, Georgia")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("8.")]), _vm._v(" Ocmulgee National Monument • Macon, Georgia")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-171"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt171"
  }, [_vm._v("9.")]), _vm._v(" Cahokia Mounds State Historic Site • Collinsville, Illinois")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("10.")]), _vm._v(" Angel Mounds State Historic Site • Evansville, Indiana")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("11.")]), _vm._v(" Poverty Point National Monument • Epps, Louisiana")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("12.")]), _vm._v(" Grand Village of the Natchez • Natchez, Mississippi")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("13.")]), _vm._v(" Town Creek Indian Mound State Historic Site • Mount Gilead, North Carolina")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("14.")]), _vm._v(" Serpent Mound • Peebles, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("15.")]), _vm._v(" SunWatch Indian Village • Dayton, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("16.")]), _vm._v(" Cemetery Mound • Marietta, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("17.")]), _vm._v(" Miamisburg Mound • Miamisburg, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("18.")]), _vm._v(" Mound City, Hopewell Culture National Historical Park • Chillicothe, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("19.")]), _vm._v(" Newark Earthworks • Newark, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("20.")]), _vm._v(" Pinson Mounds State Archaeological Park • Pinson, Tennessee")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("21.")]), _vm._v(" Grave Creek Mound Archaeological Complex • Moundsville, West Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("22.")]), _vm._v(" Aztalan Mounds State Park • Aztalan, Wisconsin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2 sgc-50 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cliff Dwellings, Great Houses, and Stone Towers")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("23.")]), _vm._v(" Montezuma Castle • Camp Verde, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("24.")]), _vm._v(" Canyon de Chelly • Chinle, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("25.")]), _vm._v(" Casa Grande Ruins National Monument • Coolidge, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("26.")]), _vm._v(" Walnut Canyon National Monument • Flagstaff, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("27.")]), _vm._v(" Wupatki National Monument • Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("28.")]), _vm._v(" Betatakin, Navajo National Monument • Shonto, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("29.")]), _vm._v(" Mesa Verde National Park • Cortez, Colorado")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("30.")]), _vm._v(" Aztec National Monument • Aztec, New Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("31.")]), _vm._v(" Chaco Canyon, Chaco Culture National Historical Park • Nageezi, New Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("32.")]), _vm._v(" Hovenweep National Monument • Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2 sgc-50 sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rock Art")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("33.")]), _vm._v(" Blythe Intaglios • Blythe, California")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("34.")]), _vm._v(" Little Petroglyph Canyon • Coso, California")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("35.")]), _vm._v(" Chumash Painted Cave State Historic Park • Santa Barbara, California")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("36.")]), _vm._v(" Petroglyph National Monument • Albuquerque, New Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("37.")]), _vm._v(" Crow Canyon • Blanco, New Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("38.")]), _vm._v(" Three Rivers Petroglyph Site • Tularosa, New Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("39.")]), _vm._v(" San Juan River • Bluff, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("40.")]), _vm._v(" Horseshoe Canyon, Canyonlands National Park • Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("41.")]), _vm._v(" Newspaper Rock State Historic Monument, Canyonlands National Park • Needles District, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("42.")]), _vm._v(" Buckhorn Wash • Emery County, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("43.")]), _vm._v(" Moab • Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("44.")]), _vm._v(" Nine Mile Canyon • Price, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("45.")]), _vm._v(" Sego Canyon • Thompson Springs, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("46.")]), _vm._v(" McConkie Ranch • Vernal, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("47.")]), _vm._v(" Dinosaur National Monument • Vernal, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("48.")]), _vm._v(" Horsethief Lake State Park • Dallesport, Washington")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("49.")]), _vm._v(" Bighorn Medicine Wheel • Bighorn National Forest, Wyoming")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-17"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt17"
  }, [_vm._v("50.")]), _vm._v(" Dinwoody Lake Petroglyphs • Crowheart, Wyoming")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Want to Know More")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Archaeology Gets Done")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Peoples")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mound Builders")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cliff Dwellings and Great Houses of the American Southwest")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rock Art")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alternative Archaeology")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 indent"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IfYouWanttoKnowMore#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Sites")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262d6358","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Toc.vue
// module id = 72
// module chunks = 0